<template>
	<div class="customer-reviews__header">
		<CustomerReviewsRatings
			:rating-label="totalRatingText.ratingLabel"
			:recommendation-rate="props.aggregatedRating.RatingRecommendationRate"
			:rating-count="aggregatedRating.RatingCount"
			:rating-overall-value="props.aggregatedRating.RatingOverallValue"
		/>
		<div class="customer-reviews__total-details">
			<CustomerReviewsDetailsGroup
				:details="aggregatedRating.Ratings"
				:is-always-open="isMinTablet"
				:max-value="RATING_MAX_VALUE"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import CustomerReviewsDetailsGroup from '@lmt-rpb/CustomerReviewsDetailsGroup/CustomerReviewsDetailsGroup.vue';
import CustomerReviewsRatings from '@lmt-rpb/CustomerReviewsRatings/CustomerReviewsRatings.vue';
import { ratingText, isMinimumRating } from '@utils/utils';
import { RATING_MAX_VALUE } from '@global-js/constants';
import type { AggregateRatingType } from '@/interfaces/review-types';
import { storeToRefs } from 'pinia';
import { useBreakpointStore } from 'src/store/breakpointsStore';

interface Props {
	aggregatedRating: AggregateRatingType;
}

const props = defineProps<Props>();

const { isMinTablet } = storeToRefs(useBreakpointStore());

const totalRatingText = computed(() => {
	const rating = {
		ratingLabel: `${ratingText(props.aggregatedRating.RatingOverallValue)} – `,
		recommendationRate: `${props.aggregatedRating.RatingRecommendationRate}`,
	};
	if (!isMinimumRating(props.aggregatedRating.RatingOverallValue)) {
		rating.ratingLabel = '';
	}
	return rating;
});
</script>

<style scoped lang="scss">
.customer-reviews {
	&__header {
		display: flex;
		flex-flow: column wrap;
		margin: 0 0 1.6rem;

		@include media-query-up($breakpoint-small) {
			flex-direction: row;
			margin-bottom: 3.2rem;
		}
	}

	&__total-details {
		width: 100%;

		@include media-query-up($breakpoint-small) {
			flex: 1 1 auto;
			width: auto;
		}

		@include media-query-up($breakpoint-large) {
			flex: 3 1 auto;
		}
	}
}
</style>
